import { useState, useEffect } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import ActivesList from './activesList';
import useListActive from '../services/activeService';
import Alert from '@mui/material/Alert';
import { Backdrop } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import ParticipantDetails from './participantDetails';

const useStyles = makeStyles((theme) => ({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  })); 


const Actives = () => {
    const classes = useStyles();
    const [showAlert, setShowAlert] = useState(true)
    const [participant, setParticipant] = useState(null)
    const { activeData, isLoadingActive, activeServerError, refresh } = useListActive();

    //useEffect(() => {
    //    console.log("Volunteers updated")
    //}, [activeData])

    useEffect(() => {
        setShowAlert(true)
    }, [isLoadingActive, setShowAlert])

    const refreshList = () => {
        refresh()
    }

    const onSelectParticiant = (selected) => {
        setParticipant(selected)
    }

    const closeDialog = () => {
        setParticipant(null)
    }

    return (
        <div>
            {(activeData) &&
                <ActivesList actives={activeData} refreshTable={refreshList} selectParticipant={onSelectParticiant}/>}
            {activeServerError && showAlert && <Alert onClose={() => {setShowAlert(false)}} severity="error">{activeServerError}</Alert>}            
            
            {participant &&<ParticipantDetails participant={participant} close={closeDialog}/>}

            <Backdrop className={classes.backdrop} open={isLoadingActive}>
                <CircularProgress color="inherit" />
            </Backdrop>
            

        </div>
    )
}

export default Actives